import { Row } from "react-bootstrap";
import CategoryPanel100 from "./CategoryPanels/CategoryPanel100";
import CategoryPanel50 from "./CategoryPanels/CategoryPanel50";
import CategoryPanel25 from "./CategoryPanels/CategoryPanel25";
import CategoryPanel50v2 from "./CategoryPanels/CategoryPanel50v2";
import { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../../services/hooks";
import { fetchLanding } from "../../../stores/landing/landingSlice";
import './landing.scss'
import { Categories } from "../../../stores/categories/categories";

export function findCategoryPath(defineTopLevel: Categories, categoryId: number, currentPath: string): string | undefined {
    for (const category of defineTopLevel) {
        const newPath = currentPath ? `${currentPath}/${category.slug}` : `${category.slug}`
        if (category.categoryId === categoryId) {
            return newPath;
        }
        if (category.subCategories) {
            const found = findCategoryPath(category.subCategories, categoryId, newPath);
            if (found) {
                return found;
            }
        }
    }
    return undefined
}

// TODO tłumaczenie
export default function Landing() {
    const dispatch = useAppDispatch()

    const landingContent = useAppSelector((state) => state.landing.data)
    const loaded = useAppSelector((state) => state.landing.loaded)

    const allCategories = useAppSelector((state) => state.categories.data)
    const categoriesLoaded = useAppSelector((state) => state.categories.loaded)

    const showPanels = Object.entries(landingContent).map(([key, value]) => {
        if (Array.isArray(value) && value.length > 0 && categoriesLoaded) {
            let categories = value.map((category, index) => {
                switch (key) {
                    case 'panelType100':
                        return <CategoryPanel100 key={index} content={value[index]} path={findCategoryPath(allCategories, category.categoryId, 'categories')} />
                    case 'panelType50':
                        return <CategoryPanel50 key={index} content={value[index]} path={findCategoryPath(allCategories, category.categoryId, 'categories')} />
                    case 'panelType50v2':
                        return <CategoryPanel50v2 key={index} content={value[index]} path={findCategoryPath(allCategories, category.categoryId, 'categories')} />
                    default:
                        return <CategoryPanel25 key={index} content={value[index]} path={findCategoryPath(allCategories, category.categoryId, 'categories')} />
                }
            })
            return categories
        }
    })

    useEffect(() => {
        dispatch(fetchLanding())
    }, [])

    return (
        <Row className="gx-1">
            {loaded && showPanels}
        </Row>
    )
}